import { OnboardingImage2, useIntl } from '@capsicum/common';
import { type FC } from 'react';

import * as S from './components.styled';
import { Shell } from './Shell';

export const ThirdPage: FC<{ goBack: () => void; next: () => void }> = ({ goBack, next }) => {
	const { $t } = useIntl();

	return (
		<Shell goBack={goBack} proceed={next}>
			<S.ImageWrapper>
				<S.Image alt="second-slide-image" data-testid="onboarding-second-slide-image" src={OnboardingImage2} />
			</S.ImageWrapper>
			<S.HeadlineText>
				{$t<JSX.Element>('onboarding.screen2Headline', {
					blue: chunks => <S.Blue>{chunks}</S.Blue>
				})}
			</S.HeadlineText>
			<S.Dropline>{$t('onboarding.screen2Dropheadline')}</S.Dropline>
		</Shell>
	);
};
